export const STRINGS = {
  PAGE_TITLE: "AI Summary Notes",
  DEFAULT_PAGINATION_LIMIT: 25,
  DEFAULT_PAGE: 1,
  NOTHING_TO_READ: "Select an element to read it",
  NO_SELECTION: "No selection made.",
  UNKNOWN: "N/A",
};

export const FILTER_OPTS = [
  { key: 1, value: false, label: "Not Copied", default: true },
  { key: 2, value: true, label: "Copied" },
];

export const DROPDOWN_OPTS = [
  { key: 1, value: "Create New Note", action: "ADD_NOTE" },
  { key: 2, value: "Copy to notes", action: "COPY_NOTE" },
];

export const MESSAGES = {
  NOTE_COPY_TO_CLIPBOARD: "Note copied to clipboard",
};

export const BUTTON_LABELS = {
  COPY_BUTTON: "Copy Note",
};
